import { render, staticRenderFns } from "./KlinikEksekutifFasilitas.vue?vue&type=template&id=74d104a8"
import script from "./KlinikEksekutifFasilitas.vue?vue&type=script&lang=js"
export * from "./KlinikEksekutifFasilitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports